import { produce } from "immer";
import {
  FETCH_AI_SUGGESTIONS,
  FETCH_AI_SUGGESTIONS_SUCCESS,
  FETCH_AI_SUGGESTIONS_FAILURE,
} from "./constants";

// Consumers (CarePlanForm) drive the pending lists via the action callbacks; this
// reducer just tracks the most recent fetch for any incidental subscribers.
export const initialState = {
  loading: false,
  last: null,
  lastError: null,
};

const AiSuggestionsReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_AI_SUGGESTIONS:
        draft.loading = true;
        draft.lastError = null;
        break;
      case FETCH_AI_SUGGESTIONS_SUCCESS:
        draft.loading = false;
        draft.last = action.payload ?? null;
        break;
      case FETCH_AI_SUGGESTIONS_FAILURE:
        draft.loading = false;
        draft.lastError = action.payload ?? true;
        break;
      default:
        return state;
    }
  });

export default AiSuggestionsReducer;
